// src/components/learning/islamic/prayerData.js
// Apprendre la prière - Contenu éducatif pour enfants

// ==================== LES ABLUTIONS (WUDU) ====================
export const wuduSteps = [
  {
    id: 1,
    name: "Intention",
    nameAr: "النِّيَّة",
    icon: "❤️",
    instruction: "Fais l'intention dans ton cœur de te purifier pour Allah",
    details: "L'intention se fait dans le cœur, pas besoin de la prononcer à voix haute.",
    dua: null,
    duaAr: null,
    image: null,
    duration: 2
  },
  {
    id: 2,
    name: "Bismillah",
    nameAr: "بِسْمِ اللَّه",
    icon: "🗣️",
    instruction: "Dis 'Bismillah' (Au nom d'Allah)",
    details: "On commence toujours par le nom d'Allah.",
    dua: "Bismillah",
    duaAr: "بِسْمِ اللَّهِ",
    image: null,
    duration: 2
  },
  {
    id: 3,
    name: "Laver les mains",
    nameAr: "غَسْل اليَدَيْن",
    icon: "🤲",
    instruction: "Lave tes mains 3 fois jusqu'aux poignets",
    details: "Commence par la main droite, puis la gauche. Frotte bien entre les doigts.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-mains.png",
    times: 3,
    duration: 5
  },
  {
    id: 4,
    name: "Rincer la bouche",
    nameAr: "المَضْمَضَة",
    icon: "👄",
    instruction: "Rince ta bouche 3 fois",
    details: "Prends de l'eau dans ta main droite, mets-la dans ta bouche, fais tourner et recrache.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-bouche.png",
    times: 3,
    duration: 5
  },
  {
    id: 5,
    name: "Rincer le nez",
    nameAr: "الاِسْتِنْشَاق",
    icon: "👃",
    instruction: "Aspire de l'eau dans ton nez et mouche 3 fois",
    details: "Aspire doucement l'eau avec ta main droite, puis mouche avec ta main gauche.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-nez.png",
    times: 3,
    duration: 5
  },
  {
    id: 6,
    name: "Laver le visage",
    nameAr: "غَسْل الوَجْه",
    icon: "😊",
    instruction: "Lave ton visage 3 fois",
    details: "Du haut du front jusqu'au menton, et d'une oreille à l'autre.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-visage.png",
    times: 3,
    duration: 8
  },
  {
    id: 7,
    name: "Laver les bras",
    nameAr: "غَسْل اليَدَيْن إِلَى المِرْفَقَيْن",
    icon: "💪",
    instruction: "Lave tes bras 3 fois jusqu'aux coudes",
    details: "Commence par le bras droit, puis le gauche. Des doigts jusqu'aux coudes inclus.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-bras.png",
    times: 3,
    duration: 10
  },
  {
    id: 8,
    name: "Essuyer la tête",
    nameAr: "مَسْح الرَّأْس",
    icon: "🧑",
    instruction: "Passe tes mains mouillées sur ta tête",
    details: "Une seule fois. Du front vers l'arrière de la tête, puis reviens.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-tete.png",
    times: 1,
    duration: 3
  },
  {
    id: 9,
    name: "Essuyer les oreilles",
    nameAr: "مَسْح الأُذُنَيْن",
    icon: "👂",
    instruction: "Essuie l'intérieur et l'extérieur des oreilles",
    details: "Avec les index à l'intérieur et les pouces à l'extérieur.",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-oreilles.png",
    times: 1,
    duration: 3
  },
  {
    id: 10,
    name: "Laver les pieds",
    nameAr: "غَسْل الرِّجْلَيْن",
    icon: "🦶",
    instruction: "Lave tes pieds 3 fois jusqu'aux chevilles",
    details: "Commence par le pied droit, puis le gauche. N'oublie pas entre les orteils !",
    dua: null,
    duaAr: null,
    image: "/images/wudu/wudu-pieds.png",
    times: 3,
    duration: 10
  },
  {
    id: 11,
    name: "Invocation finale",
    nameAr: "الدُّعَاء",
    icon: "⭐",
    instruction: "Récite l'invocation après le Wudu",
    details: "Regarde vers le ciel et récite cette belle invocation.",
    dua: "Ash-hadu an la ilaha illa Allah, wa ash-hadu anna Muhammadan 'abduhu wa rasuluh",
    duaAr: "أَشْهَدُ أَنْ لَا إِلَٰهَ إِلَّا اللَّهُ وَأَشْهَدُ أَنَّ مُحَمَّدًا عَبْدُهُ وَرَسُولُهُ",
    translation: "J'atteste qu'il n'y a pas de divinité en dehors d'Allah et que Muhammad est Son serviteur et messager",
    image: null,
    duration: 5
  }
];

// ==================== LES POSITIONS DE LA PRIÈRE ====================
export const prayerPositions = [
  {
    id: 1,
    name: "Takbir al-Ihram",
    nameAr: "تَكْبِيرَة الإِحْرَام",
    meaning: "Sacralisation",
    icon: "🙌",
    image: "/images/prayer/takbir.png",
    description: "Mains levées aux oreilles pour commencer la prière",
    details: [
      "Tiens-toi debout, face à la Qibla (direction de La Mecque)",
      "Lève tes mains jusqu'aux oreilles (ou aux épaules)",
      "Dis 'Allahu Akbar' (Allah est le plus Grand)",
      "C'est le début de ta prière, tu entres en état de sacralisation"
    ],
    recitation: ["Allahu Akbar"],
    dhikr: "اللَّهُ أَكْبَر",
    dhikrTranslation: "Allah est le plus Grand",
    color: "#ef4444"
  },
  {
    id: 2,
    name: "Qiyam",
    nameAr: "القِيَام",
    meaning: "Station debout",
    icon: "🧍",
    image: "/images/prayer/qiyam.png",
    description: "Position debout, mains croisées sur la poitrine",
    details: [
      "Tiens-toi droit, face à la Qibla",
      "Place ta main droite sur ta main gauche",
      "Pose-les sur ta poitrine",
      "Regarde vers l'endroit où tu vas te prosterner"
    ],
    recitation: ["Du'a d'ouverture", "Al-Fatiha", "Une autre sourate"],
    color: "#3b82f6"
  },
  {
    id: 3,
    name: "I'tidal",
    nameAr: "الاِعْتِدَال",
    meaning: "Redressement",
    icon: "📏",
    image: "/images/prayer/itidal.png",
    description: "Position droite après l'inclinaison, bras le long du corps",
    details: [
      "Redresse-toi complètement après le Ruku",
      "Garde les bras le long du corps",
      "Dis 'Sami'a Allahu liman hamidah' en te relevant",
      "Une fois debout, dis 'Rabbana wa lakal hamd'"
    ],
    recitation: ["Sami'a Allahu liman hamidah", "Rabbana wa lakal hamd"],
    dhikr: "سَمِعَ اللَّهُ لِمَنْ حَمِدَهُ - رَبَّنَا وَلَكَ الحَمْد",
    dhikrTranslation: "Allah entend celui qui Le loue - Notre Seigneur, à Toi la louange",
    color: "#8b5cf6"
  },
  {
    id: 4,
    name: "Ruku",
    nameAr: "الرُّكُوع",
    meaning: "Inclinaison",
    icon: "🙇",
    image: "/images/prayer/ruku.png",
    description: "Inclinaison à 90°, mains sur les genoux",
    details: [
      "Incline-toi en gardant le dos droit (comme une table)",
      "Pose tes mains sur tes genoux, doigts écartés",
      "Ta tête doit être alignée avec ton dos",
      "Dis 'Subhana Rabbiyal Adhim' 3 fois"
    ],
    recitation: ["Subhana Rabbiyal Adhim (3x)"],
    dhikr: "سُبْحَانَ رَبِّيَ العَظِيم",
    dhikrTranslation: "Gloire à mon Seigneur le Très Grand",
    color: "#10b981"
  },
  {
    id: 5,
    name: "Sujud",
    nameAr: "السُّجُود",
    meaning: "Prosternation",
    icon: "🧎",
    image: "/images/prayer/sujud.png",
    description: "Front, nez, mains, genoux et orteils au sol",
    details: [
      "Descends en posant d'abord les genoux, puis les mains",
      "Pose ton front ET ton nez sur le sol",
      "7 parties du corps touchent le sol",
      "Dis 'Subhana Rabbiyal A'la' 3 fois"
    ],
    recitation: ["Subhana Rabbiyal A'la (3x)"],
    dhikr: "سُبْحَانَ رَبِّيَ الأَعْلَى",
    dhikrTranslation: "Gloire à mon Seigneur le Très Haut",
    sevenParts: ["Front + nez", "Main droite", "Main gauche", "Genou droit", "Genou gauche", "Pied droit", "Pied gauche"],
    color: "#f59e0b"
  },
  {
    id: 6,
    name: "Juloos",
    nameAr: "الجُلُوس بَيْنَ السَّجْدَتَيْن",
    meaning: "Assis entre deux prosternations",
    icon: "🪑",
    image: "/images/prayer/juloos.png",
    description: "Position assise brève entre deux prosternations",
    details: [
      "Assieds-toi sur ton pied gauche",
      "Ton pied droit est relevé, orteils vers la Qibla",
      "Pose tes mains sur tes genoux",
      "Dis 'Rabbi ghfir li' (Seigneur pardonne-moi)"
    ],
    recitation: ["Rabbi ghfir li"],
    dhikr: "رَبِّ اغْفِرْ لِي",
    dhikrTranslation: "Seigneur, pardonne-moi",
    color: "#ec4899"
  },
  {
    id: 7,
    name: "Tashahhud",
    nameAr: "التَّشَهُّد",
    meaning: "Attestation de foi",
    icon: "☝️",
    image: "/images/prayer/tashahhud.png",
    description: "Position assise plus longue, avec le doigt levé",
    details: [
      "Assieds-toi comme pour Juloos",
      "Main gauche sur le genou gauche",
      "Main droite : poing fermé sauf l'index",
      "Pointe l'index en disant 'La ilaha illa Allah'"
    ],
    recitation: ["At-Tahiyyat", "Salat Ibrahimiya (dernier tashahhud)"],
    color: "#06b6d4"
  },
  {
    id: 8,
    name: "Taslim",
    nameAr: "التَّسْلِيم",
    meaning: "Salutation finale",
    icon: "👋",
    image: "/images/prayer/taslim.png",
    description: "Tête tournée à droite puis à gauche pour saluer",
    details: [
      "Tourne ta tête vers la droite",
      "Dis 'Assalamu alaykum wa rahmatullah'",
      "Tourne ta tête vers la gauche",
      "Dis 'Assalamu alaykum wa rahmatullah'"
    ],
    recitation: ["Assalamu alaykum wa rahmatullah (2x)"],
    dhikr: "السَّلَامُ عَلَيْكُمْ وَرَحْمَةُ اللَّه",
    dhikrTranslation: "Que la paix et la miséricorde d'Allah soient sur vous",
    color: "#22c55e"
  }
];

// ==================== LES PAROLES DE LA PRIÈRE ====================
export const prayerRecitations = [
  {
    id: 1,
    name: "Takbir",
    nameAr: "تَكْبِير",
    when: "Pour commencer et entre chaque position",
    arabic: "اللَّهُ أَكْبَر",
    transliteration: "Allahu Akbar",
    translation: "Allah est le plus Grand",
    audioKey: "takbir",
    color: "#ef4444",
    icon: "🙌"
  },
  {
    id: 2,
    name: "Du'a d'ouverture",
    nameAr: "دُعَاء الاِسْتِفْتَاح",
    when: "Après le premier Takbir (optionnel)",
    arabic: "سُبْحَانَكَ اللَّهُمَّ وَبِحَمْدِكَ وَتَبَارَكَ اسْمُكَ وَتَعَالَى جَدُّكَ وَلَا إِلَهَ غَيْرُكَ",
    transliteration: "Subhanaka Allahumma wa bihamdika, wa tabaraka ismuka, wa ta'ala jadduka, wa la ilaha ghayruk",
    translation: "Gloire à Toi, ô Allah, et louange à Toi. Béni soit Ton nom, exaltée soit Ta grandeur, et il n'y a pas de divinité en dehors de Toi",
    audioKey: "istiftah",
    color: "#8b5cf6",
    icon: "🤲"
  },
  {
    id: 3,
    name: "Ta'awwudh",
    nameAr: "التَّعَوُّذ",
    when: "Avant Al-Fatiha",
    arabic: "أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيم",
    transliteration: "A'udhu billahi min ash-shaytani ar-rajim",
    translation: "Je cherche refuge auprès d'Allah contre Satan le lapidé",
    audioKey: "taawwudh",
    color: "#6366f1",
    icon: "🛡️"
  },
  {
    id: 4,
    name: "Basmala",
    nameAr: "البَسْمَلَة",
    when: "Avant chaque sourate",
    arabic: "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيم",
    transliteration: "Bismillahi ar-rahmani ar-rahim",
    translation: "Au nom d'Allah, le Tout Miséricordieux, le Très Miséricordieux",
    audioKey: "basmala",
    color: "#3b82f6",
    icon: "📖"
  },
  {
    id: 5,
    name: "Al-Fatiha",
    nameAr: "الفَاتِحَة",
    when: "Obligatoire dans chaque unité de prière",
    arabic: "الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ ۝ الرَّحْمَٰنِ الرَّحِيمِ ۝ مَالِكِ يَوْمِ الدِّينِ ۝ إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ ۝ اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ ۝ صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَلَا الضَّالِّينَ",
    transliteration: "Al-hamdu lillahi rabbi al-'alamin. Ar-rahmani ar-rahim. Maliki yawmi ad-din. Iyyaka na'budu wa iyyaka nasta'in. Ihdina as-sirata al-mustaqim. Sirata alladhina an'amta 'alayhim ghayri al-maghdubi 'alayhim wa la ad-dallin",
    translation: "Louange à Allah, Seigneur des mondes. Le Tout Miséricordieux, le Très Miséricordieux. Maître du Jour du Jugement. C'est Toi seul que nous adorons et c'est Toi seul dont nous implorons le secours. Guide-nous dans le droit chemin. Le chemin de ceux que Tu as comblés de bienfaits, non pas de ceux qui ont encouru Ta colère, ni des égarés.",
    audioKey: "fatiha",
    note: "Dire 'Amin' à la fin",
    color: "#10b981",
    icon: "📖"
  },
  {
    id: 6,
    name: "Dhikr du Ruku",
    nameAr: "ذِكْر الرُّكُوع",
    when: "Pendant l'inclinaison (3 fois minimum)",
    arabic: "سُبْحَانَ رَبِّيَ العَظِيم",
    transliteration: "Subhana Rabbiyal Adhim",
    translation: "Gloire à mon Seigneur le Très Grand",
    audioKey: "ruku",
    times: 3,
    color: "#f59e0b",
    icon: "🙇"
  },
  {
    id: 7,
    name: "Après le Ruku",
    nameAr: "بَعْد الرُّكُوع",
    when: "En se relevant de l'inclinaison",
    arabic: "سَمِعَ اللَّهُ لِمَنْ حَمِدَهُ",
    transliteration: "Sami'a Allahu liman hamidah",
    translation: "Allah entend celui qui Le loue",
    response: "رَبَّنَا وَلَكَ الحَمْد",
    responseTranslit: "Rabbana wa lakal hamd",
    responseTranslation: "Notre Seigneur, à Toi la louange",
    audioKey: "sami",
    color: "#8b5cf6",
    icon: "🧍"
  },
  {
    id: 8,
    name: "Dhikr du Sujud",
    nameAr: "ذِكْر السُّجُود",
    when: "Pendant la prosternation (3 fois minimum)",
    arabic: "سُبْحَانَ رَبِّيَ الأَعْلَى",
    transliteration: "Subhana Rabbiyal A'la",
    translation: "Gloire à mon Seigneur le Très Haut",
    audioKey: "sujud",
    times: 3,
    color: "#ec4899",
    icon: "🙏"
  },
  {
    id: 9,
    name: "Entre les prosternations",
    nameAr: "بَيْنَ السَّجْدَتَيْن",
    when: "Assis entre les deux prosternations",
    arabic: "رَبِّ اغْفِرْ لِي",
    transliteration: "Rabbi ghfir li",
    translation: "Seigneur, pardonne-moi",
    audioKey: "ghfirli",
    color: "#06b6d4",
    icon: "🧎"
  },
  {
    id: 10,
    name: "At-Tahiyyat",
    nameAr: "التَّحِيَّات",
    when: "Assis pour le Tashahhud",
    arabic: "التَّحِيَّاتُ لِلَّهِ وَالصَّلَوَاتُ وَالطَّيِّبَاتُ، السَّلَامُ عَلَيْكَ أَيُّهَا النَّبِيُّ وَرَحْمَةُ اللَّهِ وَبَرَكَاتُهُ، السَّلَامُ عَلَيْنَا وَعَلَى عِبَادِ اللَّهِ الصَّالِحِينَ، أَشْهَدُ أَنْ لَا إِلَهَ إِلَّا اللَّهُ وَأَشْهَدُ أَنَّ مُحَمَّدًا عَبْدُهُ وَرَسُولُهُ",
    transliteration: "At-tahiyyatu lillahi was-salawatu wat-tayyibat. As-salamu 'alayka ayyuha an-nabiyyu wa rahmatullahi wa barakatuh. As-salamu 'alayna wa 'ala 'ibadillahi as-salihin. Ash-hadu an la ilaha illa Allah wa ash-hadu anna Muhammadan 'abduhu wa rasuluh",
    translation: "Les salutations sont pour Allah, ainsi que les prières et les bonnes œuvres. Que la paix soit sur toi, ô Prophète, ainsi que la miséricorde d'Allah et Ses bénédictions. Que la paix soit sur nous et sur les vertueux serviteurs d'Allah. J'atteste qu'il n'y a pas de divinité en dehors d'Allah et j'atteste que Muhammad est Son serviteur et messager",
    audioKey: "tahiyyat",
    color: "#1f2937",
    icon: "☝️"
  },
  {
    id: 11,
    name: "Salat Ibrahimiya",
    nameAr: "الصَّلَاة الإِبْرَاهِيمِيَّة",
    when: "Après At-Tahiyyat dans le dernier Tashahhud",
    arabic: "اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ، اللَّهُمَّ بَارِكْ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا بَارَكْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ",
    transliteration: "Allahumma salli 'ala Muhammad wa 'ala ali Muhammad, kama sallayta 'ala Ibrahim wa 'ala ali Ibrahim, innaka Hamidun Majid. Allahumma barik 'ala Muhammad wa 'ala ali Muhammad, kama barakta 'ala Ibrahim wa 'ala ali Ibrahim, innaka Hamidun Majid",
    translation: "Ô Allah, prie sur Muhammad et sur la famille de Muhammad, comme Tu as prié sur Ibrahim et sur la famille d'Ibrahim. Tu es certes Digne de louange et de gloire. Ô Allah, bénis Muhammad et la famille de Muhammad, comme Tu as béni Ibrahim et la famille d'Ibrahim. Tu es certes Digne de louange et de gloire",
    audioKey: "ibrahimiya",
    color: "#22c55e",
    icon: "🤲"
  },
  {
    id: 12,
    name: "Taslim",
    nameAr: "التَّسْلِيم",
    when: "Pour terminer la prière (2 fois)",
    arabic: "السَّلَامُ عَلَيْكُمْ وَرَحْمَةُ اللَّه",
    transliteration: "Assalamu alaykum wa rahmatullah",
    translation: "Que la paix et la miséricorde d'Allah soient sur vous",
    audioKey: "taslim",
    times: 2,
    note: "D'abord à droite, puis à gauche",
    color: "#10b981",
    icon: "👋"
  }
];

// ==================== STRUCTURE D'UNE PRIÈRE COMPLÈTE ====================
export const prayerStructure = {
  oneRaka: [
    { step: "Takbir d'ouverture (Allahu Akbar)", position: "debout", icon: "🙌" },
    { step: "Du'a d'ouverture (optionnel)", position: "debout", icon: "🤲" },
    { step: "Al-Fatiha", position: "debout", icon: "📖" },
    { step: "Une sourate", position: "debout", icon: "📖" },
    { step: "Takbir + Ruku", position: "incliné", icon: "🙇" },
    { step: "Subhana Rabbiyal Adhim (3x)", position: "incliné", icon: "🙇" },
    { step: "Sami'a Allahu liman hamidah", position: "redressement", icon: "🧍" },
    { step: "Rabbana wa lakal hamd", position: "debout", icon: "🧍" },
    { step: "Takbir + 1ère prosternation", position: "prosterné", icon: "🙏" },
    { step: "Subhana Rabbiyal A'la (3x)", position: "prosterné", icon: "🙏" },
    { step: "Takbir + assis", position: "assis", icon: "🧎" },
    { step: "Rabbi ghfir li", position: "assis", icon: "🧎" },
    { step: "Takbir + 2ème prosternation", position: "prosterné", icon: "🙏" },
    { step: "Subhana Rabbiyal A'la (3x)", position: "prosterné", icon: "🙏" }
  ],
  
  tashahhudMiddle: [
    { step: "Takbir + assis", position: "assis", icon: "🧎" },
    { step: "At-Tahiyyat", position: "assis", icon: "☝️" }
  ],
  
  tashahhudFinal: [
    { step: "Takbir + assis", position: "assis", icon: "🧎" },
    { step: "At-Tahiyyat", position: "assis", icon: "☝️" },
    { step: "Salat Ibrahimiya", position: "assis", icon: "🤲" },
    { step: "Taslim à droite", position: "assis", icon: "👋" },
    { step: "Taslim à gauche", position: "assis", icon: "👋" }
  ]
};

// ==================== LES 5 PRIÈRES QUOTIDIENNES ====================
export const dailyPrayers = [
  {
    id: 1,
    name: "Fajr",
    nameAr: "الفَجْر",
    meaning: "L'Aube",
    rakaat: 2,
    time: "Avant le lever du soleil",
    icon: "🌅",
    color: "#f59e0b",
    structure: "2 unités avec Tashahhud final"
  },
  {
    id: 2,
    name: "Dhuhr",
    nameAr: "الظُّهْر",
    meaning: "Midi",
    rakaat: 4,
    time: "Après le zénith du soleil",
    icon: "☀️",
    color: "#eab308",
    structure: "4 unités : Tashahhud milieu après 2, final après 4"
  },
  {
    id: 3,
    name: "Asr",
    nameAr: "العَصْر",
    meaning: "L'Après-midi",
    rakaat: 4,
    time: "L'après-midi",
    icon: "🌤️",
    color: "#f97316",
    structure: "4 unités : Tashahhud milieu après 2, final après 4"
  },
  {
    id: 4,
    name: "Maghrib",
    nameAr: "المَغْرِب",
    meaning: "Le Coucher du soleil",
    rakaat: 3,
    time: "Juste après le coucher du soleil",
    icon: "🌇",
    color: "#ef4444",
    structure: "3 unités : Tashahhud milieu après 2, final après 3"
  },
  {
    id: 5,
    name: "Isha",
    nameAr: "العِشَاء",
    meaning: "La Nuit",
    rakaat: 4,
    time: "La nuit, après la disparition du crépuscule",
    icon: "🌙",
    color: "#6366f1",
    structure: "4 unités : Tashahhud milieu après 2, final après 4"
  }
];

// ==================== QUIZ ====================
export const prayerQuiz = [
  {
    category: "wudu",
    question: "Par quelle partie du corps commence-t-on les ablutions ?",
    options: ["Les pieds", "Le visage", "Les mains", "La tête"],
    correct: "Les mains",
    explanation: "On commence par laver les mains 3 fois"
  },
  {
    category: "wudu",
    question: "Combien de fois lave-t-on le visage pendant le Wudu ?",
    options: ["1 fois", "2 fois", "3 fois", "4 fois"],
    correct: "3 fois",
    explanation: "On lave le visage 3 fois pendant les ablutions"
  },
  {
    category: "positions",
    question: "Comment s'appelle la position debout dans la prière ?",
    options: ["Ruku", "Sujud", "Qiyam", "Juloos"],
    correct: "Qiyam",
    explanation: "Qiyam signifie 'debout' en arabe"
  },
  {
    category: "positions",
    question: "Combien de parties du corps touchent le sol pendant le Sujud ?",
    options: ["5", "6", "7", "8"],
    correct: "7",
    explanation: "Front+nez, 2 mains, 2 genoux, 2 pieds = 7 parties"
  },
  {
    category: "recitations",
    question: "Que dit-on pendant le Ruku ?",
    options: ["Allahu Akbar", "Subhana Rabbiyal Adhim", "Subhana Rabbiyal A'la", "Amin"],
    correct: "Subhana Rabbiyal Adhim",
    explanation: "On dit 'Subhana Rabbiyal Adhim' (Gloire à mon Seigneur le Très Grand)"
  },
  {
    category: "recitations",
    question: "Quelle sourate est obligatoire dans chaque unité de prière ?",
    options: ["Al-Ikhlas", "Al-Fatiha", "An-Nas", "Al-Kawthar"],
    correct: "Al-Fatiha",
    explanation: "Al-Fatiha est récitée dans chaque unité (raka'a) de la prière"
  },
  {
    category: "daily",
    question: "Combien de prières obligatoires fait-on chaque jour ?",
    options: ["3", "4", "5", "7"],
    correct: "5",
    explanation: "Les 5 prières : Fajr, Dhuhr, Asr, Maghrib, Isha"
  },
  {
    category: "daily",
    question: "Quelle prière a seulement 2 unités (raka'at) ?",
    options: ["Dhuhr", "Fajr", "Maghrib", "Isha"],
    correct: "Fajr",
    explanation: "La prière de Fajr (l'aube) n'a que 2 unités"
  }
];

// ==================== ENCOURAGEMENTS ====================
export const prayerEncouragements = {
  correct: [
    "🌟 Mashallah ! Tu connais bien ta prière !",
    "⭐ Excellent ! Qu'Allah accepte tes prières !",
    "🎉 Bravo ! Continue d'apprendre !",
    "💫 Super ! Tu es sur le bon chemin !"
  ],
  wrong: [
    "💪 Ce n'est pas grave, réessaie !",
    "📖 Revois cette partie et réessaie !",
    "🤲 Avec de la pratique, tu y arriveras !"
  ],
  complete: [
    "🏆 Félicitations ! Tu connais les bases de la prière !",
    "🌟 Mashallah ! Continue à pratiquer chaque jour !",
    "⭐ Qu'Allah accepte tes efforts !"
  ]
};

// ==================== BADGES ====================
export const prayerBadges = {
  wudu: { icon: "💧", name: "Maître du Wudu", description: "Tu connais les étapes des ablutions" },
  positions: { icon: "🙏", name: "Positions Parfaites", description: "Tu connais toutes les positions de la prière" },
  recitations: { icon: "📖", name: "Récitateur", description: "Tu connais les paroles de la prière" },
  complete: { icon: "🕌", name: "Petit Musalli", description: "Tu sais comment faire la prière complète" }
};

export default {
  wuduSteps,
  prayerPositions,
  prayerRecitations,
  prayerStructure,
  dailyPrayers,
  prayerQuiz,
  prayerEncouragements,
  prayerBadges
};
